import React from 'react';
import PropTypes from 'prop-types';
import { compose, withState, withHandlers, setPropTypes, withProps } from 'recompose';
import { Collapse } from 'reactstrap';
import { includes } from 'lodash';
import cn from 'classnames';

import withViewportSize from 'hoc/withViewportSize';

const CollapsibleContent = ({ enabled, children, className, title, isOpen, toggleIsOpen }) => (
  <div className={cn(
    'collapsible-content',
    `${className}`,
    { [`${className}--is-open`]: isOpen },
    { 'collapsible-content--is-open': isOpen },
    { 'collapsible-content--disabled': !enabled })}
  >
    <button
      className={cn(`${className}__toggle`, 'collapsible-content__toggle')}
      type="button"
      onClick={toggleIsOpen}
      disabled={!enabled}
    >
      <h6 className={cn(
        `${className}__heading`,
        'collapsible-content__heading')}
      >{title}</h6>
    </button>
    <Collapse
      className={cn(
        `${className}__body`,
        'collapsible-content__body',
      )}
      isOpen={isOpen || !enabled}
    >
      {children}
    </Collapse>
  </div>
);

CollapsibleContent.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  toggleIsOpen: PropTypes.func,
  enabled: PropTypes.bool,
};

const enhance = compose(
  withViewportSize,
  withProps(({ viewportSize, enableForSizes }) => ({
    enabled: !enableForSizes || includes([].concat(enableForSizes), viewportSize),
  })),
  withState('isOpen', 'setIsOpen', ({ openByDefault }) => openByDefault),
  withHandlers({
    toggleIsOpen: ({ setIsOpen, enabled }) => () => enabled && setIsOpen(x => !x),
  }),
  setPropTypes({
    openByDefault: PropTypes.bool,
    enableForSizes: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
    ]),
  }),
);

export default enhance(CollapsibleContent);



// WEBPACK FOOTER //
// ./src/components/CollapsibleContent.js